import { BookOpen, Flame, LockKeyhole, Radio } from "lucide-react";

import { AionMark } from "../components/AionMark";

export const SignInPage = ({
  error,
  onSignIn,
}: {
  error?: string | null;
  onSignIn: () => void;
}) => (
  <main className="sign-in-page">
    <div className="sign-in-orbit sign-in-orbit--one" />
    <div className="sign-in-orbit sign-in-orbit--two" />

    <section className="sign-in-card">
      <div>
        <AionMark />
        <span className="eyebrow">Personal intelligence · owned by you</span>
        <h1>Give what you know a place to live.</h1>
        <p className="sign-in-card__intro">
          Ignis keeps your thoughts, sources, and decisions. Incus turns your
          lecture briefs into a growing library of models and connections.
        </p>
      </div>

      <div className="sign-in-features">
        <div>
          <Flame />
          <span>
            <strong>Capture at the wrist</strong>
            Voice, text, and sources
          </span>
        </div>
        <div>
          <BookOpen />
          <span>
            <strong>Browse in Ignis</strong>
            Read-only canonical knowledge
          </span>
        </div>
        <div>
          <Radio />
          <span>
            <strong>Retrieve through Aion</strong>
            Source-aware answers in Slack
          </span>
        </div>
      </div>

      <button className="primary-button" onClick={onSignIn} type="button">
        <LockKeyhole size={17} />
        Continue with the owner account
      </button>

      {error ? <p className="form-error">{error}</p> : null}
      <small>Restricted to the Aion owner. Your library is not public.</small>
    </section>
  </main>
);

